import { create } from 'zustand';

import { EasyPlanHomeInfo } from '../types/easy-plan.types';

type State = {
  initialEasyPlan: {};
  easyPlanHomeInfo: EasyPlanHomeInfo;
};

const initialState: State = {
  initialEasyPlan: {},
  easyPlanHomeInfo: {
    easyPlan: {
      about: {
        title: '',
        description: '',
        footerDescription: '',
        tileList: [
          { title: '', subtitle: '', image: '', link: '' },
          { title: '', subtitle: '', image: '', link: '' },
          { title: '', subtitle: '', image: '', link: '' },
        ],
      },
      cost: {
        title: '',
        description: '',
        footerDescription: '',
        breakdown: {
          title: '',
          types: [
            {
              title: '',
              charges: '',
            },
            {
              title: '',
              charges: '',
            },
            {
              title: '',
              charges: '',
            },
          ],
        },
        tileList: [],
      },
      perks: {
        title: '',
        description: '',
        footerDescription: '',
        tileList: [
          { title: '', subtitle: '', image: '', link: '' },
          { title: '', subtitle: '', image: '', link: '' },
          { title: '', subtitle: '', image: '', link: '' },
          { title: '', subtitle: '', image: '', link: '' },
          { title: '', subtitle: '', image: '', link: '' },
        ],
      },
      welcome: {
        title: '',
        description: '',
        footerDescription: '',
        tileList: [],
      },
    },
  },
};

type EasyPlanStore = {
  initialEasyPlan: {};
  easyPlanHomeInfo: EasyPlanHomeInfo;
  saveEasyPlanHomeInfo: (easyPlanHomeInfo: any) => void;
  resetState: () => void;
};

const useEasyPlanStore = create<EasyPlanStore>((set) => ({
  ...initialState,
  saveEasyPlanHomeInfo: (easyPlanHomeInfo: any) => set({ easyPlanHomeInfo }),
  resetState: () => {
    set(initialState);
  },
}));

export default useEasyPlanStore;
